import React from 'react';
import { IconCircleCheck } from '@tabler/icons-react';

import { useTranslate } from '@src/core/hooks';

import {
  AccountCardEditButton,
  AccountCardEmail,
  AccountCardHeader,
  AccountCardLabel,
  AccountCardRoot,
  AccountCardTitle,
} from '../styles';

type AccountStepCardProps = {
  email: string;
  onEdit?: () => void;
};

export const AccountStepCard = (props: AccountStepCardProps) => {
  const { email, onEdit } = props;
  const { i18n } = useTranslate();

  return (
    <AccountCardRoot data-testid='account-step-card'>
      <AccountCardHeader>
        <AccountCardLabel>
          <IconCircleCheck size={28} aria-hidden />
          <AccountCardTitle>{i18n('checkout_payment_account_title')}</AccountCardTitle>
        </AccountCardLabel>

        {onEdit ? (
          <AccountCardEditButton type='button' onClick={onEdit}>
            {i18n('checkout_payment_account_edit')}
          </AccountCardEditButton>
        ) : null}
      </AccountCardHeader>

      <AccountCardEmail>{email}</AccountCardEmail>
    </AccountCardRoot>
  );
};

export default AccountStepCard;
